import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { SendWizardStep } from '../types';

interface SendFooterActionsProps {
  step: SendWizardStep;
  canContinue: boolean;
  isSubmitting?: boolean;
  onCancel: () => void;
  onBackStep: () => void;
  onContinue: () => void;
}

export const SendFooterActions: React.FC<SendFooterActionsProps> = ({
  step,
  canContinue,
  isSubmitting = false,
  onCancel,
  onBackStep,
  onContinue,
}) => {
  const continueDisabled = !canContinue || isSubmitting;
  const isReview = step === 3;
  const isMessage = step === 2;

  if (isReview) {
    return (
      <div className="flex items-center justify-between gap-6">
        <Button
          type="button"
          variant="outline"
          onClick={onBackStep}
          disabled={isSubmitting}
          className="h-9 rounded-lg border-[#E5E5E5] px-4 shadow-none"
        >
          Voltar
        </Button>
        <Button
          type="button"
          variant="dark"
          onClick={onContinue}
          disabled={continueDisabled}
          className={cn(
            'h-9 rounded-lg px-4 shadow-none',
            continueDisabled &&
              'disabled:bg-gray-300 disabled:text-white disabled:opacity-100'
          )}
        >
          {isSubmitting ? 'Enviando...' : 'Enviar report'}
        </Button>
      </div>
    );
  }

  if (isMessage) {
    return (
      <div className="flex w-full items-center justify-between gap-6 border-0 py-8">
        <Button
          type="button"
          variant="outline"
          onClick={onBackStep}
          disabled={isSubmitting}
          className="h-9 rounded-lg border-[#E5E5E5] px-4 shadow-none"
        >
          Voltar
        </Button>
        <Button
          type="button"
          variant="dark"
          onClick={onContinue}
          disabled={continueDisabled}
          className={cn(
            'h-9 rounded-lg px-4 shadow-none',
            continueDisabled &&
              'disabled:bg-gray-300 disabled:text-white disabled:opacity-100'
          )}
        >
          Continuar
        </Button>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-between gap-6 border-0 py-8">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        disabled={isSubmitting}
        className="h-9 rounded-lg border-[#E5E5E5] px-4 shadow-none"
      >
        Cancelar
      </Button>
      <Button
        type="button"
        variant="dark"
        onClick={onContinue}
        disabled={continueDisabled}
        className={cn(
          'h-9 rounded-lg px-4 shadow-none',
          continueDisabled &&
            'disabled:bg-gray-300 disabled:text-white disabled:opacity-100'
        )}
      >
        Continuar
      </Button>
    </div>
  );
};
